export default "__VITE_ASSET__DrTFVLuP__"